import { render } from "./AllMembers.vue?vue&type=template&id=5484b008"
import script from "./AllMembers.vue?vue&type=script&lang=js"
export * from "./AllMembers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__